/* Atelier — facets.js : filtres et tri sans rechargement (Section Rendering API).
   Amélioration progressive : sans JS, le formulaire GET et les liens fonctionnent. */

(() => {
  if (customElements.get('facets-controller')) return;

  class FacetsController extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.baseUrl = this.dataset.url || window.location.pathname;
      this.root = document.querySelector(`[data-section-id="${this.sectionId}"]`) || document;
      this.cache = new Map();

      this.onFormChange = this.debounce((form, target) => this.submitForm(form, target), 350);
      document.addEventListener('input', (e) => {
        const form = e.target.closest('[data-facets-form]');
        if (!form || !this.root.contains(form)) return;
        if (e.target.type === 'number') this.onFormChange(form, e.target);
      });
      document.addEventListener('change', (e) => {
        const form = e.target.closest('[data-facets-form]');
        if (form && this.root.contains(form) && e.target.type !== 'number') { this.submitForm(form, e.target); return; }
        if (e.target.matches('[data-sort-select]') && this.root.contains(e.target)) {
          const params = new URLSearchParams(window.location.search);
          params.set('sort_by', e.target.value);
          params.delete('page');
          this.render(params.toString());
        }
      });
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('[data-facets-form]');
        if (!form || !this.root.contains(form)) return;
        e.preventDefault();
        this.submitForm(form);
      });
      document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (!link || !this.root.contains(link)) return;
        e.preventDefault();
        const url = new URL(link.href, window.location.origin);
        this.render(url.searchParams.toString());
      });
      window.addEventListener('popstate', () => this.render(window.location.search.slice(1), false));
    }

    debounce(fn, wait) { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); }; }

    submitForm(form, target) {
      const data = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, value] of data.entries()) {
        if (value !== '') params.append(key, value);
      }
      const sortTop = this.root.querySelector('[data-sort-select]');
      if (!params.get('sort_by') && sortTop) params.set('sort_by', sortTop.value);
      params.delete('page');
      this.render(params.toString(), true, target?.id);
    }

    async render(query, push = true, focusId) {
      const grid = this.root.querySelector(`#ProductGrid-${this.sectionId}`);
      grid?.setAttribute('aria-busy', 'true');
      const sep = query ? '&' : '';
      const fetchUrl = `${this.baseUrl}?${query}${sep}section_id=${this.sectionId}`;
      try {
        let html = this.cache.get(fetchUrl);
        if (!html) {
          const res = await fetch(fetchUrl);
          if (!res.ok) throw new Error(res.status);
          html = await res.text();
          this.cache.set(fetchUrl, html);
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-facets-replace]').forEach((fresh) => {
          const current = this.root.querySelector(`#${CSS.escape(fresh.id)}`);
          if (current) current.innerHTML = fresh.innerHTML;
        });
        const filterButton = this.root.querySelector('.collection-toolbar__filter');
        const freshButton = doc.querySelector('.collection-toolbar__filter');
        if (filterButton && freshButton) filterButton.innerHTML = freshButton.innerHTML;
        const drawerFooter = this.root.querySelector(`#FacetDrawer-${this.sectionId} .drawer__footer`);
        const freshFooter = doc.querySelector(`#FacetDrawer-${this.sectionId} .drawer__footer`);
        if (drawerFooter && freshFooter) drawerFooter.innerHTML = freshFooter.innerHTML;
        const sortTop = this.root.querySelector('[data-sort-select]');
        const freshSort = doc.querySelector('[data-sort-select]');
        if (sortTop && freshSort) sortTop.value = freshSort.value;

        if (push) window.history.pushState({}, '', query ? `${this.baseUrl}?${query}` : this.baseUrl);
        if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
      } catch (e) {
        window.location.href = query ? `${this.baseUrl}?${query}` : this.baseUrl;
      } finally {
        this.root.querySelector(`#ProductGrid-${this.sectionId}`)?.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('facets-controller', FacetsController);
})();
